import { Expose } from "class-transformer";

export class UpdateQuestionOrderDto {
  @Expose()
  id: string;

  @Expose()
  order: number;
}
